/*
 * @Author: zxf
 * @Date: 2021-12-15 14:27:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-01-28 17:41:38
 * @Description: file content
 * @FilePath: \neolix-map-sdk\src\snap\SnapFeatureVectors.js
 */

import SnapActor from "./SnapActor";
export default class SnapFeatureVectors extends SnapActor{
    constructor(options) {
        super(options);
		this.type = 'SnapFeatureVectors';
    }

    snap(point) {
        return this.getMousePointCloudIntersection(
			point, camera, viewer, pointclouds, params);
    }

    getMousePointCloudIntersection (mouse, camera, viewer, pointclouds) {
		let renderer = viewer.renderer;
		
		let nmouse = {
			x: (mouse.x / renderer.domElement.clientWidth) * 2 - 1,
			y: -(mouse.y / renderer.domElement.clientHeight) * 2 + 1
		};

		let pickParams = {};

		pickParams.x = mouse.x;
		pickParams.y = renderer.domElement.clientHeight - mouse.y;
		pickParams.pickClipped = true;

		let raycaster = new THREE.Raycaster();
		raycaster.setFromCamera(nmouse, camera);
		let ray = raycaster.ray;

		let selectedPointcloud = null;
		let closestDistance = Infinity;
		let closestIntersection = null;
		let closestPoint = null;
		
		for(let pointcloud of pointclouds){
			let point = pointcloud.pick(viewer, camera, ray, pickParams);
			
			if(!point){
				continue;
			}

			let distance = camera.position.distanceTo(point.position);

			if (distance < closestDistance) {
				closestDistance = distance;
				selectedPointcloud = pointcloud;
				closestIntersection = point.position;
				closestPoint = point;
			}
		}

		if (selectedPointcloud) {
			return {
				location: closestIntersection,
				distance: closestDistance,
				pointcloud: selectedPointcloud,
				point: closestPoint
			};
		} else {
			return null;
		}
	}
}